import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {from, of, ReplaySubject} from 'rxjs';
import {AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {Contract} from '../../../shared/interface/contract';
import {InsuranceCompany} from '../../../shared/interface/insurance-company';
import {OfwcaRegistrationInfo} from '../../../shared/interface/ofwca-registration-info';
import {RegistrationService} from '../../../shared/services/registration.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {FormHelperService} from '../../../shared/services/form-helper.service';
import {
  CONTRACT_TYPE_PROFIT,
  DICT_TYPE_REGISTRATION_ID_TYPE,
  DICT_TYPE_REGISTRATION_STATUS,
  DictService,
  REGISTRATION_ID_TYPE_SENT,
  REGISTRATION_STATUS_BLOCKED,
  REGISTRATION_STATUS_DEREGISTERED,
  REGISTRATION_STATUS_REGISTERED,
  REGISTRATION_STATUS_SENT_TO_BLOCK,
  REGISTRATION_STATUS_SENT_TO_DEREGISTER,
  REGISTRATION_STATUS_SENT_TO_REGISTER_IN_INSURANCE_COMPANY,
  REGISTRATION_STATUS_TO_BLOCK,
  REGISTRATION_STATUS_TO_DEREGISTER,
  REGISTRATION_ID_TYPE_CONSENT_TO_DUAL_REGISTRATION,
  REGISTRATION_ID_TYPE_REQUEST_FOR_DELETION_SENT,
  COMMISSION_JOB_STATUS_PENDING,
  FILE_TYPE_ANOTHER_MULTI,
  DYNAMIC_DICTIONARY_MANAGER_WIENER,
  SALES_COMPENSA_WIENER,
  SALES_COMPENSA,
  DYNAMIC_DICTIONARY_COMPENSA_OFFICE,
  DYNAMIC_DICTIONARY_COMPENSA_OFFICE_PROFIT,
} from '../../../shared/services/dict.service';
import {delay, distinctUntilChanged, first, last, take, takeUntil, tap} from 'rxjs/operators';
import {Dictionary} from '../../../shared/interface/dictionary';
import {Uuid} from '../../../shared/interface/response/uuid';
import {HttpErrorResponse} from '@angular/common/http';
import {Registration} from '../../../shared/interface/registration';
import {validNip} from '../../../shared/validator/nip-validator';
import {
  IC_ALLIANZ,
  IC_COMPENSA, IC_COMPENSA_LIFE,
  IC_EUROP_ASSISTANCE,
  IC_EUROPA,
  IC_LINK4,
  IC_PZU,
  IC_PZU_LIFE, IC_TRASTI,
  IC_WIENER
} from '../../../shared/services/insurance-company.service';
import {Ofwca} from '../../../shared/interface/ofwca';
import {OfwcaService} from '../../../shared/services/ofwca.service';
import {ContractService} from '../../../shared/services/contract.service';
import {RegistrationIdentifier} from '../../../shared/interface/registration-identifier';
import {ListResponse} from '../../../shared/interface/response/list-response';
import {IdentifierService} from '../../../shared/services/identifier.service';
import {MatSlideToggleChange} from '@angular/material/slide-toggle';
import {AuthService} from '../../../shared/services/auth.service';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import moment from 'moment';
import {Regional} from "../../../shared/interface/regional";
import {htmlAstToRender3Ast} from "@angular/compiler/src/render3/r3_template_transform";
import {validPhoneNumber} from "../../../shared/validator/phone-validator";
import {Document} from "../../../shared/interface/document";
import {DocumentService} from "../../../shared/services/document.service";

export interface RegistrationIdInlineForm {
  currentIdentifierId?: string;
  identifierName: string;
  typeDict: Dictionary;
  formGroup: FormGroup;
}

@Component({
  selector: 'app-registration-details-form',
  templateUrl: './registration-details-form.component.html',
  styleUrls: ['./registration-details-form.component.scss']
})
export class RegistrationDetailsFormComponent implements OnInit, OnDestroy {
  @Input() registrationObject?: Registration;
  @Output() closeModification = new EventEmitter<any>();

  readonly IC_PZU = IC_PZU;
  readonly IC_PZU_LIFE = IC_PZU_LIFE;
  readonly IC_LINK4 = IC_LINK4;
  readonly IC_ALLIANZ = IC_ALLIANZ;
  readonly REGISTRATION_ID_TYPE_SENT = REGISTRATION_ID_TYPE_SENT;
  readonly DEREGISTER_STATUSES = [
    REGISTRATION_STATUS_DEREGISTERED,
    REGISTRATION_STATUS_TO_DEREGISTER,
    REGISTRATION_STATUS_SENT_TO_DEREGISTER
  ];
  readonly CONTRACT_TYPE_PROFIT = CONTRACT_TYPE_PROFIT;
  readonly REGISTRATION_ID_TYPE_REQUEST_FOR_DELETION_SENT = REGISTRATION_ID_TYPE_REQUEST_FOR_DELETION_SENT;
  readonly REGISTRATION_ID_TYPE_CONSENT_TO_DUAL_REGISTRATION = REGISTRATION_ID_TYPE_CONSENT_TO_DUAL_REGISTRATION;
  readonly CHRONIE_INSURANCE_COMPANIES = [
    IC_WIENER,
    IC_EUROPA
  ];
  readonly FILE_TYPE_ANOTHER_MULTI = FILE_TYPE_ANOTHER_MULTI;
  readonly  DYNAMIC_DICTIONARY_MANAGER_WIENER = DYNAMIC_DICTIONARY_MANAGER_WIENER;
  readonly DYNAMIC_DICTIONARY_COMPENSA_OFFICE = DYNAMIC_DICTIONARY_COMPENSA_OFFICE;
  readonly DYNAMIC_DICTIONARY_COMPENSA_OFFICE_PROFIT = DYNAMIC_DICTIONARY_COMPENSA_OFFICE_PROFIT;



  registrationForm: FormGroup;
  ofwcaControl: FormControl;
  contractControl: FormControl;
  insuranceCompanyControl: FormControl;
  whatIsNeededControl: FormControl;
  doubleRegistrationControl: FormControl;
  salesProfilesControl: FormControl;
  statusControl: FormControl;
  registrationCompensaOfficeNewControl: FormControl;
  registrationFacilityAddressGroup: FormGroup;
  chronieLoginControl: FormControl;
  sentToBlockControl: FormControl;
  blockedControl: FormControl;
  dateOfReceiptOfStatementsControl: FormControl;
  registrationFacilityAddressPzuGroup: FormGroup;
  sentToInsuranceCompanyToRegisterDateControl: FormControl;
  dateOfRegistrationControl: FormControl;
  assetsRegionalControl: FormControl;
  lifeRegionalControl: FormControl;
  currentEntityOfRegistrationControl: FormControl;
  commentsControl: FormControl;
  selectedContract?: Contract;
  selectedInsuranceCompany?: InsuranceCompany;
  selectedStatus?: Dictionary;
  contractCompanyId: ReplaySubject<number> = new ReplaySubject<number>(1);
  showAllContracts = false;
  ofwcaRegistrationInfo?: OfwcaRegistrationInfo;
  ofwcaContracts: ReplaySubject<Contract[]> = new ReplaySubject<Contract[]>(1);
  processingRequest = false;
  errors: any = {};
  availableSalesProfiles = false;
  registrationFormValid = false;
  salesProfilesDictTypeSubject: ReplaySubject<string> = new ReplaySubject<string>(1);
  selectedOfwca?: Ofwca;
  requireCompensaData = false;
  // requireTrastiData = false;
  userPermissions: UserPermissions;
  registrationIdForms: { [key: string]: RegistrationIdInlineForm } = {};
  forceShowInsuranceCompanyId: number;
  userPermissionss: ReplaySubject<UserPermissions>;
  disable = false;
  registrationCompensaLifeOfficeControl: FormControl;
  requireCompensaLifeData = false;
  missingExamControl: FormControl;
  document: Document;
  documentInformationScanControl: FormControl;
  documentInformationOriginalControl: FormControl;
  documentInformationDocumentMissingControl: FormControl;
  registrationDocumentMissingControl: FormControl;
  hiperioTestAccessControl: FormControl;
  lockedPzuVerificationData = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private registrationService: RegistrationService,
    private snackBar: MatSnackBar,
    private router: Router,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private dictService: DictService,
    private contractService: ContractService,
    private ofwcaService: OfwcaService,
    private identifierService: IdentifierService,
    private documentService: DocumentService,
    private auth: AuthService,
  ) {
    this.userPermissionss = auth.getUserPermissions();
    this.registrationForm = this.fb.group({
      contract: this.contractControl = fb.control('', [Validators.required]),
      showAllContracts: fb.control(false),
      insuranceCompany: this.insuranceCompanyControl = fb.control('', [Validators.required]),
      whatIsNeeded: this.whatIsNeededControl = fb.control('', [Validators.required]),
      doubleRegistration: this.doubleRegistrationControl = fb.control('', [Validators.required]),
      salesProfiles: this.salesProfilesControl = fb.control([], [Validators.required]),
      status: this.statusControl = fb.control('', [Validators.required]),
      statements: fb.control(''),
      registrationNip: fb.control('', [validNip(), Validators.required]),
      registrationFacilityAddress: this.registrationFacilityAddressGroup = this.formHelper.generateAddressFormGroup(),
      registrationOfwcaOwner: fb.control('', [Validators.required]),
      registrationCompanyName: fb.control('', [Validators.required]),
      registrationPartnerEmail: fb.control('', [Validators.required, Validators.email]),
      agreedToDeregister: fb.control(false),
      deregisterReason: fb.control('', [Validators.required]),
      missingStatements: fb.control(''),
      note: fb.control(''),
      agreedToRegisterInPzu: fb.control(false),
      pzuVerificationSupplement: fb.control(false),
      importedToCandidateApplication: fb.control(false),
      consentsAndDeclarations: fb.control(false),
      sentToPzuForVerification: fb.control(false),
      registrationCompensaOfficeNew: this.registrationCompensaOfficeNewControl = fb.control('', [Validators.required]),
      // hasAllianzCert: fb.control(false),
      chronieLogin: this.chronieLoginControl = fb.control('', [Validators.email, Validators.required]),
      sentToBlock: this.sentToBlockControl = fb.control(false),
      blocked: this.blockedControl = fb.control(false),
      dateOfReceiptOfStatements: this.dateOfReceiptOfStatementsControl = fb.control(''),
      sentToInsuranceCompanyToRegisterDate: this.sentToInsuranceCompanyToRegisterDateControl = fb.control(''),
      dateOfRegistration: this.dateOfRegistrationControl = fb.control(''),
      lifeRegional: this.lifeRegionalControl = fb.control(''),
      assetsRegional: this.assetsRegionalControl = fb.control(''),
      registrationAgencyName: fb.control(''),
      registrationFacilityAddressPzu: this.registrationFacilityAddressPzuGroup = this.formHelper.generateAddressFormGroup(true),
      // trastiEmail:  fb.control('', [Validators.email, Validators.required]),
      currentEntityOfRegistration: this.currentEntityOfRegistrationControl = fb.control(''),
      comments: this.commentsControl = fb.control(''),
      registrationCompensaLifeOffice: this.registrationCompensaLifeOfficeControl = fb.control('', [Validators.required]),
      additionalEmail: fb.control('', [Validators.email]),
      additionalPhone: fb.control('', [validPhoneNumber()]),
      missingExam: this.missingExamControl = fb.control(''),
      documentInformationScan: this.documentInformationScanControl = fb.control(false),
      documentInformationOriginal: this.documentInformationOriginalControl = fb.control(false),
      documentInformationDocumentMissing: this.documentInformationDocumentMissingControl = fb.control(false),
      registrationDocumentMissing: this.registrationDocumentMissingControl = fb.control(false),
      hiperioTestAccess: this.hiperioTestAccessControl = fb.control('', []),
    });

    this.blockedControl.disable();
    this.auth.getUserPermissions()
      .subscribe((userPermissions: UserPermissions) => {
        this.userPermissions = userPermissions;
      });
  }

  getControl(group: FormGroup, name: string): FormControl {
    return group.get(name) as FormControl;
  }

  ngOnInit(): void {
    if (!this.userPermissions.registration.delete){
      this.contractControl.disable();
      this.insuranceCompanyControl.disable();
      // this.doubleRegistrationControl.disable();
      // this.whatIsNeededControl.disable();
      this.salesProfilesControl.disable();
      this.registrationCompensaOfficeNewControl.disable();
      this.sentToInsuranceCompanyToRegisterDateControl.disable();
      this.dateOfRegistrationControl.disable();
      this.disable = true;
      this.registrationForm.get('showAllContracts').disable();
      this.registrationForm.get('registrationNip').disable();
      this.registrationForm.get('registrationAgencyName').disable();
      this.registrationForm.get('registrationOfwcaOwner').disable();
      this.registrationForm.get('registrationCompanyName').disable();
      this.registrationForm.get('registrationPartnerEmail').disable();
      // this.registrationForm.get('hasAllianzCert').disable();
      this.registrationForm.get('agreedToRegisterInPzu').disable();
      this.registrationForm.get('pzuVerificationSupplement').disable();
      this.registrationForm.get('importedToCandidateApplication').disable();
      this.registrationForm.get('consentsAndDeclarations').disable();
      this.registrationForm.get('sentToPzuForVerification').disable();
      this.registrationForm.get('statements').disable();
      this.registrationForm.get('sentToBlock').disable();
      this.registrationForm.get('blocked').disable();
      this.registrationForm.get('agreedToDeregister').disable();
    }
    this.registrationForm.valueChanges
      .pipe(
        delay(0),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => this.registrationFormValid = this.registrationForm.valid);

    this.registrationForm.get('showAllContracts').valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((val: boolean) => this.showAllContracts = val);


    this.registrationService.getOfwcaRegistrationInfo(this.registrationObject.ofwca.uuid)
      .subscribe((ofwcaRegistrationInfo: OfwcaRegistrationInfo) => {
        this.ofwcaRegistrationInfo = ofwcaRegistrationInfo;
        this.ofwcaContracts.next(ofwcaRegistrationInfo.contracts);
      });

    this.documentInformationScanControl.valueChanges
      .pipe(takeUntil(this.destroyed$), distinctUntilChanged())
      .subscribe((val: boolean) => {
        if (val) {
          this.documentInformationOriginalControl.setValue(false);
          this.documentInformationDocumentMissingControl.setValue(false);
        }
      });

    this.documentInformationOriginalControl.valueChanges
      .pipe(takeUntil(this.destroyed$), distinctUntilChanged())
      .subscribe((val: boolean) => {
        if (val) {
          this.documentInformationScanControl.setValue(false);
          this.documentInformationDocumentMissingControl.setValue(false);
        }
      });

    this.documentInformationDocumentMissingControl.valueChanges
      .pipe(takeUntil(this.destroyed$), distinctUntilChanged())
      .subscribe((val: boolean) => {
        if (val) {
          this.documentInformationOriginalControl.setValue(false);
          this.documentInformationScanControl.setValue(false);
        }
      });

    this.initialize(this.registrationObject);
  }
  // oneRequiredValidator(): ValidatorFn {
  //   return (group: AbstractControl): { [key: string]: any } | null => {
  //     if (!this.registrationObject?.documentAnotherMulti){
  //       return null;
  //     }
  //
  //     const checkedCount = [
  //       group.get('documentInformationScan')?.value,
  //       group.get('documentInformationOriginal')?.value,
  //       group.get('documentInformationDocumentMissing')?.value
  //     ].filter(Boolean).length;
  //
  //     return checkedCount === 1 ? null : { oneRequired: true };
  //   };
  // }

  buildIdentifierForms(): void {
    this.dictService.getDictSubject()
      .pipe(
        first()
      )
      .subscribe((items: Dictionary[]) => {

        this.registrationService.getRegistrationIds(this.registrationObject.uuid)
          .pipe(first())
          .subscribe((response: ListResponse<RegistrationIdentifier>) => {
            items.forEach((dict: Dictionary) => {
              if ([REGISTRATION_ID_TYPE_REQUEST_FOR_DELETION_SENT,
                  REGISTRATION_ID_TYPE_CONSENT_TO_DUAL_REGISTRATION,
                  REGISTRATION_ID_TYPE_SENT].includes(dict.key) &&
                dict.type === DICT_TYPE_REGISTRATION_ID_TYPE && this.registrationObject
                && this.registrationObject.insuranceCompany.registrationIdTypes.includes(dict.key)
                && (!dict.secured || (dict.secured && this.userPermissions.registration.id_import))
              ) {

                let exists = false;
                response.items.forEach((identifier: RegistrationIdentifier) => {
                  if (dict.key === identifier.type.key) {
                    this.registrationIdForms[dict.key] = {
                      identifierName: dict.name,
                      currentIdentifierId: identifier.uuid,
                      typeDict: dict,
                      formGroup: this.fb.group({
                        registration: this.fb.control(this.registrationObject.uuid),
                        type: this.fb.control(dict.id),
                        value: this.fb.control(this.parseValue(identifier.value, dict)),
                      })
                    };
                    exists = true;
                  }
                });

                if (!exists) {
                  this.registrationIdForms[dict.key] = {
                    identifierName: dict.name,
                    currentIdentifierId: null,
                    typeDict: dict,
                    formGroup: this.fb.group({
                      registration: this.fb.control(this.registrationObject.uuid),
                      type: this.fb.control(dict.id),
                      value: this.fb.control(''),
                    })
                  };
                }
              }
            });
          });
      });
  }

  parseValue(value: string, type: Dictionary): string|string[] {
    if (!value) {
      return '';
    }

    if (type.valueType === 'bool') {
      if (value.toLowerCase() === 'tak') {
        return 'Tak';
      } else {
        return 'Nie';
      }
    } else {
      return value.split(',');
    }
  }

  initialize(registration: Registration): void {
    of(registration)
      .pipe(
        delay(0),
        tap(() => {
          this.forceShowInsuranceCompanyId = registration.insuranceCompany.id;
          this.registrationForm.reset({
            contract: registration.contract.uuid,
            showAllContracts: registration.showAllContracts,
            insuranceCompany: registration.insuranceCompany.id,
            whatIsNeeded: registration.whatIsNeeded?.id,
            doubleRegistration: registration.doubleRegistration?.id,
            salesProfiles: registration.salesProfiles.map((salesProfile: Dictionary) => salesProfile.id),
            status: registration.status.id,
            statements: registration.statements,
            registrationNip: registration.registrationNip,
            registrationAgencyName: registration.registrationAgencyName,
            registrationOfwcaOwner: registration.registrationOfwcaOwner,
            registrationCompanyName: registration.registrationCompanyName,
            registrationPartnerEmail: registration.registrationPartnerEmail,
            agreedToDeregister: registration.agreedToDeregister,
            deregisterReason: registration.deregisterReason,
            missingStatements: registration.missingStatements,
            note: registration.note,
            // trastiEmail: registration.trastiEmail,
            agreedToRegisterInPzu: registration.agreedToRegisterInPzu,
            pzuVerificationSupplement: registration.pzuVerificationSupplement,
            importedToCandidateApplication: registration.importedToCandidateApplication,
            consentsAndDeclarations: registration.consentsAndDeclarations,
            sentToPzuForVerification: registration.sentToPzuForVerification,
            // hasAllianzCert: registration.hasAllianzCert,
            sentToBlock: registration.sentToBlock,
            blocked: registration.blocked,
            lifeRegional: registration.lifeRegional?.uuid || '',
            assetsRegional: registration.assetsRegional?.uuid || '',
            currentEntityOfRegistration: registration.currentEntityOfRegistration,
            comments: registration.comments,
            dateOfReceiptOfStatements: registration.dateOfReceiptOfStatements ? moment(registration.dateOfReceiptOfStatements) : '',
            sentToInsuranceCompanyToRegisterDate: registration.sentToInsuranceCompanyToRegisterDate ?
              moment(registration.sentToInsuranceCompanyToRegisterDate) : '',
            registrationCompensaOffice: registration.registrationCompensaOffice?.id,
            dateOfRegistration: registration.dateOfRegistration ?
              moment(registration.dateOfRegistration) : '',
            registrationCompensaLifeOffice: registration.registrationCompensaLifeOffice?.id,
            additionalEmail: registration.additionalEmail,
            additionalPhone: registration.additionalPhone,
            registrationCompensaWienerManager: registration.registrationCompensaWienerManager?.id,
            registrationCompensaOfficeNew: registration.registrationCompensaOfficeNew?.id,
            missingExam: registration.missingExam?.id,
            documentInformationScan: registration.documentAnotherMulti?.documentInformationScan ?? false,
            documentInformationOriginal: registration.documentAnotherMulti?.documentInformationOriginal ?? false,
            documentInformationDocumentMissing: registration.documentAnotherMulti?.documentInformationDocumentMissing ?? false,
            registrationDocumentMissing: registration.registrationDocumentMissing,
            hiperioTestAccess: registration.hiperioTestAccess
          });
          this.registrationForm.get('assetsRegional').setValue(this.registrationObject?.assetsRegional?.uuid);
          if (registration.sentToBlock) {
            this.blockedControl.enable();
          }

          if (registration.registrationFacilityAddress) {
            this.formHelper.setAddress(registration.registrationFacilityAddress, this.registrationFacilityAddressGroup);
          }
          if (registration.registrationFacilityAddressPzu) {
            this.formHelper.setAddress(registration.registrationFacilityAddressPzu, this.registrationFacilityAddressPzuGroup);
          }

          this.ofwcaService.get(registration.ofwca.uuid)
            .subscribe((ofwca: Ofwca) => {
              this.selectedOfwca = ofwca;
              this.updateChronieForm();
            });
          this.contractService.get(registration.contract.uuid)
            .subscribe((contract: Contract) => this.contractChanged(contract));

          this.insuranceCompanyChanged(registration.insuranceCompany, true);
          this.statusChanged(registration.status, false);
          this.buildIdentifierForms();
        }),
        delay(0),
        tap(() => {
          this.initialized.next(true);
        })
      ).subscribe();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  whatIsNeededChanged(dict: Dictionary): void {

  }

  contractChanged(contract: Contract): void {
    this.contractCompanyId.next(contract.company.id);
    this.selectedContract = contract;
  }

  save(): void {
    // if (  this.registrationForm.get('insuranceCompany').value.key === IC_PZU)
    // {
    //   this.formHelper.setAddress( this.registrationForm.get('registrationFacilityAddressPzu').value,
    //     this.registrationFacilityAddressGroup);
    // }
    this.processingRequest = true;
    const forms = [];

    for (const [key, value] of Object.entries(this.registrationIdForms)) {
      forms.push(value);
    }

    if (forms.length === 0) {
      forms.push(null);
    }
    if (this.registrationObject.documentAnotherMulti){
      const formData = {
        documentInformationScan: this.documentInformationScanControl.value,
        documentInformationOriginal: this.documentInformationOriginalControl.value,
        documentInformationDocumentMissing: this.documentInformationDocumentMissingControl.value
      };
      this.documentService.updateDocumentInformation(formData, this.registrationObject.documentAnotherMulti.uuid)
        .pipe(first())
        .subscribe();
    }

    from(forms)
      .pipe(
        tap((inlineForm: RegistrationIdInlineForm) => {
          if (!inlineForm) {
            return;
          }

          const idValue = inlineForm.formGroup.get('value').value;

          this.identifierService.sendForm({
            registration: inlineForm.formGroup.get('registration').value,
            type: inlineForm.formGroup.get('type').value,
            value: Array.isArray(idValue) ? idValue : [idValue],
          }, inlineForm.currentIdentifierId)
            .subscribe();
          return;
        })
      ).pipe(last()).subscribe(() => {
      this.registrationService.sendForm(this.registrationForm.getRawValue(), this.registrationObject.uuid)
        .pipe(
          first()
        )
        .subscribe((response: Uuid) => {
          this.snackBar.open('Pomyślnie zaktualizowano rejestrację', '', {
            duration: 2000,
          });
          this.processingRequest = false;

          this.closeModification.emit();
        }, (error: HttpErrorResponse) => {
          this.processingRequest = false;

          this.snackBar.open('Podczas przesyłania formularza wystąpił błąd', error.status.toString(), {
            duration: 2000,
          });

          if (error.status === 400) {
            this.errors = error.error.error.list;
            this.formHelper.setBackendErrorState(this.registrationForm, this.errors);
          }
        });
    });
  }

  cancel(): void {
    this.closeModification.emit();
  }

  updatePzuValidation(): void {
    const isAdmin = this.userPermissions.registration.admin_root;

    if (!isAdmin) {
      this.registrationForm.get('registrationNip').setValidators([validNip(), Validators.required]);
      this.registrationForm.get('registrationAgencyName').setValidators([Validators.required]);
      this.updatePzuAddressValidation(true);
    } else {
      this.registrationForm.get('registrationNip').setValidators([validNip()]);
      this.registrationForm.get('registrationAgencyName').clearValidators();
      this.updatePzuAddressValidation(false);
    }

    this.registrationForm.get('registrationNip').updateValueAndValidity();
    this.registrationForm.get('registrationAgencyName').updateValueAndValidity();
  }

  updatePzuAddressValidation(required: boolean): void {
    const addressControls = [
      'street', 'houseNumber', 'city', 'zipCode', 'state', 'district', 'commune', 'postCity'
    ];

    addressControls.forEach(controlName => {
      const control = this.registrationFacilityAddressPzuGroup.get(controlName);
      if (control) {
        if (required) {
          if (controlName === 'zipCode') {
            control.setValidators([
              Validators.required,
              Validators.minLength(6),
              Validators.pattern('^[0-9]{2,5}(:|\\-)?[0-9]{3,4}')
            ]);
          } else {
            control.setValidators([Validators.required]);
          }
        } else {
          control.clearValidators();

          if (controlName === 'zipCode' && control.value) {
            control.setValidators([
              Validators.minLength(6),
              Validators.pattern('^[0-9]{2,5}(:|\\-)?[0-9]{3,4}')
            ]);
          }
        }
        control.updateValueAndValidity();
      }
    });
  }

  insuranceCompanyChanged(insuranceCompany: InsuranceCompany, initialize: boolean): void {
    if (!initialize) {
      this.salesProfilesControl.setValue([]);
    }
    this.availableSalesProfiles = false;

    this.dictService.getDictSubject()
      .pipe(first())
      .subscribe((items: Dictionary[]) => {
        items.forEach((dict: Dictionary) => {
          if (dict.type === 'sales_' + insuranceCompany.key) {
            this.availableSalesProfiles = true;
          }
        });
      });

    this.selectedInsuranceCompany = insuranceCompany;

    if (this.availableSalesProfiles) {
      this.registrationForm.get('salesProfiles').enable();
      this.salesProfilesDictTypeSubject.next('sales_' + insuranceCompany.key);
    } else {
      this.registrationForm.get('salesProfiles').disable();
    }

    if (insuranceCompany && insuranceCompany.key === IC_COMPENSA) {
      this.requireCompensaData = true;
      this.registrationCompensaOfficeNewControl.enable();
    } else {
      this.requireCompensaData = false;
      this.registrationCompensaOfficeNewControl.disable();
    }

    if (insuranceCompany && insuranceCompany.key === IC_COMPENSA_LIFE) {
      this.requireCompensaLifeData = true;
      this.registrationCompensaLifeOfficeControl.enable();
    } else {
      this.requireCompensaLifeData = false;
      this.registrationCompensaLifeOfficeControl.disable();
    }

    // if (insuranceCompany && insuranceCompany.key === IC_TRASTI) {
    //   this.requireTrastiData = true;
    //   this.registrationForm.get('trastiEmail').enable();
    // } else {
    //   this.requireTrastiData = false;
    //   this.registrationForm.get('trastiEmail').disable();
    // }

    if (insuranceCompany?.key === IC_LINK4) {
      this.registrationForm.get('registrationNip').enable();
      this.registrationForm.get('registrationOfwcaOwner').enable();
      this.registrationForm.get('registrationCompanyName').enable();
      this.registrationForm.get('registrationPartnerEmail').enable();
      this.registrationForm.get('registrationFacilityAddress').enable();
      this.registrationForm.get('registrationAgencyName').disable();
      this.registrationForm.get('registrationFacilityAddressPzu').disable();
      this.registrationForm.get('additionalEmail').enable();
      this.registrationForm.get('additionalPhone').enable();

      if (!initialize) {
        this.registrationForm.get('registrationNip').setValue(this.registrationObject?.ofwca?.partner?.nip);
        this.registrationForm.get('registrationOfwcaOwner').setValue(this.selectedContract?.partner?.owner?.fullName);
        this.registrationForm.get('registrationCompanyName').setValue(this.selectedContract?.partner?.fullName);
        this.registrationForm.get('registrationPartnerEmail').setValue(this.selectedContract?.partner?.primaryEmails[0]?.address);
        if (this.selectedOfwca?.facility?.address) {
          this.formHelper.setAddress(this.selectedOfwca.facility.address, this.registrationFacilityAddressGroup);
        }
      }

    }  else if (insuranceCompany?.key === IC_PZU) {
      this.updatePzuValidation();
      this.registrationForm.get('registrationNip').enable();
      this.registrationForm.get('registrationAgencyName').enable();
      this.registrationForm.get('registrationFacilityAddress').disable();
      this.registrationForm.get('registrationFacilityAddressPzu').enable();
      this.registrationForm.get('registrationOfwcaOwner').disable();
      this.registrationForm.get('registrationCompanyName').disable();
      this.registrationForm.get('registrationPartnerEmail').disable();
      this.registrationForm.get('additionalEmail').enable();
      this.registrationForm.get('additionalPhone').enable();
    } else if (insuranceCompany && insuranceCompany.key === IC_PZU_LIFE) {
      this.updatePzuValidation();
      this.registrationForm.get('additionalEmail').enable();
      this.registrationForm.get('additionalPhone').enable();
      this.registrationForm.get('registrationNip').enable();
      this.registrationForm.get('registrationOfwcaOwner').disable();
      this.registrationForm.get('registrationCompanyName').disable();
      this.registrationForm.get('registrationPartnerEmail').disable();
      this.registrationForm.get('registrationFacilityAddress').disable();
      this.registrationForm.get('registrationAgencyName').enable();
      this.registrationForm.get('registrationFacilityAddressPzu').enable();
      // this.registrationForm.get('registrationNip').setValue('');
      this.registrationForm.get('registrationOfwcaOwner').setValue('');
      this.registrationForm.get('registrationCompanyName').setValue('');
      this.registrationForm.get('registrationPartnerEmail').setValue('');
    }else {
      this.registrationForm.get('additionalEmail').disable();
      this.registrationForm.get('additionalPhone').disable();
      this.registrationForm.get('registrationNip').disable();
      this.registrationForm.get('registrationOfwcaOwner').disable();
      this.registrationForm.get('registrationCompanyName').disable();
      this.registrationForm.get('registrationPartnerEmail').disable();
      this.registrationForm.get('registrationFacilityAddress').disable();
      this.registrationForm.get('registrationAgencyName').disable();
      this.registrationForm.get('registrationFacilityAddressPzu').disable();
      this.registrationForm.get('registrationNip').setValue('');
      this.registrationForm.get('registrationOfwcaOwner').setValue('');
      this.registrationForm.get('registrationCompanyName').setValue('');
      this.registrationForm.get('registrationPartnerEmail').setValue('');
    }

    this.updateChronieForm();
  }

  statusChanged(status: Dictionary, afterInitialization = true): void {
    this.selectedStatus = status;

    if (this.DEREGISTER_STATUSES.includes(status.key)) {
      this.registrationForm.get('deregisterReason').enable();
      this.registrationForm.get('agreedToDeregister').enable();
    } else {
      this.registrationForm.get('deregisterReason').disable();
      this.registrationForm.get('deregisterReason').reset();
      this.registrationForm.get('agreedToDeregister').disable();
      this.registrationForm.get('agreedToDeregister').reset();
    }

    if (afterInitialization && status.key === REGISTRATION_STATUS_SENT_TO_REGISTER_IN_INSURANCE_COMPANY) {
      this.sentToInsuranceCompanyToRegisterDateControl.setValue(moment());
    }

    if (afterInitialization && status.key === REGISTRATION_STATUS_REGISTERED) {
      this.dateOfRegistrationControl.setValue(moment());
    }
  }

  updateChronieForm(): void {
    if (
      [IC_WIENER, IC_EUROPA, IC_EUROP_ASSISTANCE].includes(this.selectedInsuranceCompany?.key)
      && !this.selectedOfwca?.chronieLogin
    ) {
      this.chronieLoginControl.enable();

      if (!this.chronieLoginControl.value) {
        this?.selectedOfwca.emails.forEach((email) => {
          if (email.main ){
            this.chronieLoginControl.setValue(email.address);
          }
        });
      }
    } else {
      this.chronieLoginControl.disable();
    }
  }

  sentToBlockChanged($event: MatSlideToggleChange): void {
    if ($event.checked) {
      this.blockedControl.enable();

      this.dictService.getKey(this.statusControl.value)
        .subscribe((key: string) => {
          if (key === REGISTRATION_STATUS_TO_BLOCK) {
            this.dictService.getId(REGISTRATION_STATUS_SENT_TO_BLOCK, DICT_TYPE_REGISTRATION_STATUS)
              .subscribe((dictId: number) => {
                this.statusControl.setValue(dictId);
              });
          }
        });
    } else {
      this.blockedControl.disable();
    }
  }

  blockedChanged($event: MatSlideToggleChange): void {
    if ($event.checked) {
      this.dictService.getKey(this.statusControl.value)
        .subscribe((key: string) => {
          if ([REGISTRATION_STATUS_TO_BLOCK, REGISTRATION_STATUS_SENT_TO_BLOCK].includes(key)) {
            this.dictService.getId(REGISTRATION_STATUS_BLOCKED, DICT_TYPE_REGISTRATION_STATUS)
              .subscribe((dictId: number) => {
                this.statusControl.setValue(dictId);
              });
          }
        });
    }
  }

  downloadPartner(): void{
      this.ofwcaService.get(this.registrationObject.ofwca.uuid)
        .subscribe((ofwca: Ofwca) => {
          if (ofwca.facility) {
            this.formHelper.setPzuAddress(ofwca.facility.address, this.registrationFacilityAddressPzuGroup);
          }
        });

    this.contractService.get(this.contractControl.value).subscribe((contract: Contract) => {
      this.registrationForm.get('registrationNip').setValue(contract?.partner?.nip);
      this.registrationForm.get('registrationAgencyName').setValue(contract?.partner?.fullName);
    });

  }
}
